"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCollectLogs = void 0;
const initialization_1 = require("./diagnostic-channel/initialization");
(0, initialization_1.enablePublishers)();
class AutoCollectLogs {
    enable(options) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            require("./diagnostic-channel/console.sub").enable(options.console);
        }
        catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            require("../../../out/src/logs/diagnostic-channel/console.sub").enable(options.console);
        }
    }
    shutdown() {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            require("./diagnostic-channel/console.sub").dispose();
        }
        catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            require("../../../out/src/logs/diagnostic-channel/console.sub").dispose();
        }
    }
}
exports.AutoCollectLogs = AutoCollectLogs;
//# sourceMappingURL=autoCollectLogs.js.map